import {
  compose,
  allPass,
  includes,
  ifElse,
  map,
  gte
} from "../../js/lib/functional.js";

export const getCharLen = str => [...str].length;

const byteLen = str => new Blob([str]).size;

const control_chars = [
  "\x00",
  "\x01",
  "\x02",
  "\x03",
  "\x04",
  "\x05",
  "\x06",
  "\x07",
  "\b",
  "\t",
  "\n",
  "\x0B",
  "\f",
  "\r",
  "\x0E",
  "\x0F",
  "\x10",
  "\x11",
  "\x12",
  "\x13",
  "\x14",
  "\x15",
  "\x16",
  "\x17",
  "\x18",
  "\x19",
  "\x1A",
  "\x1B",
  "\x1C",
  "\x1D",
  "\x1E",
  "\x1F"
];

export const forbidden_printable_chars = [
  "/", // (forward slash)
  "<", // (less than)
  ">", // (greater than)
  ":", // (colon - sometimes works, but is actually NTFS Alternate Data Streams)
  '"', // (double quote)
  "/", // (forward slash)
  `\\`, // (backslash)
  "|", // (vertical bar or pipe)
  "?", // (question mark)
  "*" // (asterisk)
];

const includesNoForbiddenChar = allPass(
  map(
    char => s => !includes(char, s),
    [...forbidden_printable_chars, ...control_chars]
  )
);

const winbasename = compose(
  b => b.toUpperCase(),
  s => s.split(".")[0]
);

const forbidden_winbasenames = [
  "CON",
  "PRN",
  "AUX",
  "NUL",
  "COM1",
  "COM2",
  "COM3",
  "COM4",
  "COM5",
  "COM6",
  "COM7",
  "COM8",
  "COM9",
  "LPT1",
  "LPT2",
  "LPT3",
  "LPT4",
  "LPT5",
  "LPT6",
  "LPT7",
  "LPT8",
  "LPT9"
];

const hasNoForbiddenWinBaseName = compose(
  b => !includes(b, forbidden_winbasenames),
  winbasename
);

const withinNTFSLength = compose(gte(255), getCharLen);

const withinMostUnixLengths = compose(gte(255), byteLen);

export const passes = (string, maxCharLen) =>
  allPass([
    includesNoForbiddenChar,
    hasNoForbiddenWinBaseName,
    ifElse(
      () => maxCharLen,
      compose(gte(maxCharLen), getCharLen),
      () => true
    ),
    withinNTFSLength,
    withinMostUnixLengths,
    s => !s.startsWith("_"),
    s => !s.startsWith(".")
  ])(string);
